export const CONSENT_COOKIE = '__oaiq_consent';

let pending: any[][] = [];
let polls = 0;
let timer: ReturnType<typeof setTimeout> | null = null;

const POLL_MS = 100;
const MAX_POLLS = 100;

export const isStoredConsentGranted = (): boolean => {
  if (typeof document === 'undefined') return false;

  try {
    const m = document.cookie.match(
      new RegExp(`(?:^|; )${CONSENT_COOKIE}=([^;]*)`),
    );
    return m ? decodeURIComponent(m[1]) === 'true' : false;
  } catch {
    return false;
  }
};

type OaiqFn = (...args: any[]) => void;

const getOaiq = (): OaiqFn | undefined => {
  if (typeof window === 'undefined') return undefined;
  const fn = (window as any).oaiq;
  return typeof fn === 'function' ? fn : undefined;
};

const drain = () => {
  timer = null;
  const oaiq = getOaiq();

  if (!oaiq) {
    polls += 1;
    if (polls > MAX_POLLS) {
      pending = [];
      polls = 0;
      return;
    }

    timer = setTimeout(drain, POLL_MS);
    return;
  }

  polls = 0;
  const calls = pending;
  pending = [];
  for (const args of calls) {
    try {
      oaiq(...args);
    } catch {}
  }
};

export const enqueueOaiq = (...args: any[]) => {
  if (typeof window === 'undefined') return;
  pending.push(args);
  if (!timer) drain();
};

export const clearPendingOaiq = () => {
  pending = [];
};
